// The UTC time starts at 8 am in Shanghai time zone every day.
// To make the epoch switch at 10 am every day, we need to add 2 hours to the UTC time.
const SHANGHAI_WORKING_ZONE_OFFSET = BigInt(3600 * 2); // 2 hours in seconds
const ONE_DAY_IN_SECONDS = 86400n;

export const getCurrentEpochStartTimestamp = (): bigint => {
  const now = BigInt(Math.floor(Date.now() / 1000)); // current time in seconds
  const currentEpochDay =
    (now - SHANGHAI_WORKING_ZONE_OFFSET) / ONE_DAY_IN_SECONDS;
  
return currentEpochDay * ONE_DAY_IN_SECONDS;
};

export const getNextEpochStartTimestamp = (): bigint => {
  return getCurrentEpochStartTimestamp() + ONE_DAY_IN_SECONDS;
};
